export default "__VITE_ASSET__Sz8kauFJ__"